import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_INPUT_GENERICO, ESTILO_BOTON_GENERAL_CANCELAR } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
// import { crearCategoria, modificarCategoria } from "../../../api/api-categoria";
// import cargandoCard from "../../../components/cargando-card";
// import { obtenerListaCategoria } from "../../../api/api-categoria";
// import Select from "react-select";
import Spinner from "../../components/spinner";
import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { actualizarSubEstadosIncidente, crearSubEstadosIncidente } from "../../api/api-sub-estados-incidente";

export default function SubEstadoIncidentePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [params, setParams] = useState(null);
  const [titulo, setTitulo] = useState("");
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [requestSend, setRequestSend] = useState(false);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.formData);
        setParams(data.params);
        setTitulo(data.titulo);
      }
      // const categorias = await obtenerListaCategoria({ habilitado: 1 }, true);
      // setListaCategoria(categorias);
      // if (data.params.idCategoria !== undefined && data.params.idCategoria !== null) {
      //   const categoria = categorias.find((item) => item.value === data.params.idCategoria);
      //   setCategoriaSelected(categoria);
      // }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setParams({
        ...params,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(params.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }

      if (message.length > 0) {
        showToast(message.trim(), "warning", 4000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    // console.log('params');
    // console.log(params);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = params.id;
    objEnviar.idEstadoIncidente = formData.id;
    objEnviar.codigo = params?.codigo ?? "";
    objEnviar.descripcion = params.descripcion;
    objEnviar.nota = params.nota;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    setRequestSend(true);
    setProcessingVisible(true);
    try {
      if (params.id === 0) {
        // console.log('crear correo');
        const response = await crearSubEstadosIncidente(objEnviar);
        setProcessingVisible(false);
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (params.id !== 0) {
        // console.log('actualizar correo');
        const response = await actualizarSubEstadosIncidente(objEnviar);
        setProcessingVisible(false);
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
      setProcessingVisible(false);
    } finally {
      setRequestSend(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}:{formData?.descripcion}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={params?.codigo ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{params?.codigo?.length ?? 0}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={params?.descripcion ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{params?.descripcion?.length ?? 0}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={params?.nota ?? ""}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{params?.nota?.length ?? 0}/{charLimits.nota}</p>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  {requestSend === false && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      {t("label_aceptar")}
                    </button>
                  )}
                  {requestSend === true && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      disabled
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Spinner size="sm" color="white" />
                        <span>{t("label_aceptar")}</span>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('Sub Estado Incidente render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
